vec3 effect(vec2 uv)
{
    return sampleCam(uv);
}
